import React,{ Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { ItemTypes } from './Constants';
import { DragSource, DropTarget } from 'react-dnd';
import { addBlock } from '../actions/index';

import mySectionsData from '../helpers/MySectionsData';

const blockSource = {
  beginDrag(props){
    return {
      type: 'block',
      element: props.element
    }
  }
}


class MySectionItem extends Component {

  deleteThisItem(){
    if (!window.confirm("Do you really want to delete this saved section?")) {
      return;
    }
    var request = {
      'option' : 'com_sppagebuilder',
      'task' : 'page.deleteSection',
      'id' : this.props.element.id
    };

    jQuery.ajax({
      type   : 'POST',
      data   : request,
      success: (response) => {
        if( response){

          mySectionsData.deleteSection(this.props.index);
        }
      }
    });
  }

  render(){
    const { element, isDragging, connectDropTarget, connectDragPreview, connectDragSource } = this.props;

    return connectDragPreview(connectDragSource(
      <li>
        <div className="sppb-my-saved-section-item">
          <i className="fa fa-cube" />
          <span>{element.title}</span>
          <ul className="pull-right">
            <li><a href="#" onClick={e => {
              e.preventDefault();

              this.deleteThisItem()

            }}><i className="fa fa-times" /> Delete</a></li>
          </ul>
        </div>
      </li>
    ))
  }
}

var DragSourceDecorator = DragSource(ItemTypes.BLOCK, blockSource,
  function(connect, monitor) {
    return {
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
      isDragging: monitor.isDragging()
    };
  }
);


const mapStateToProps = ( state ) => {
  return {state};
}

const mapDispatchToProps = ( dispatch ) => {
  return {
    addBlock: ( rowIndex, dragIndex, hoverIndex ) => {
      dispatch(addBlock(rowIndex, dragIndex, hoverIndex))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DragSourceDecorator(MySectionItem));



// WEBPACK FOOTER //
// ./src/components/MySectionItem.js